import { Component, OnInit, Input, Output, EventEmitter }
    from "@angular/core";
import { EmailTemplate, Pagination } from "../../../models";
import { USERHOMECONSTANTS } from "../userHome.constants";
import { CurrentUserService }
    from "../../../services/shared";
import { EmailTemplatesService } from "./emailTemplates.service";
import { UserHomeService } from "../userHome.service";
import { ChangeDetectorRef } from "@angular/core";

@Component({
    selector: "emailTemplates-component",
    template: require("./emailTemplates.component.html"),
    styles: [require("./emailTemplates.component.less").toString()],
    providers: [EmailTemplatesService]
})

export class EmailTemplatesComponent implements OnInit {
    @Input() emailTemplateList: EmailTemplate[];
    @Output() refreshList: EventEmitter<any> = new EventEmitter();
    emailTemplate: EmailTemplate;
    errorMessage: string;
    hasViewPermission: boolean;
    templateEditMode: boolean;
    emailTemplatesComponent = {
        sortColumnIndex: 1,
        sortOrder: USERHOMECONSTANTS.sorting.ascOrderString,
        sortColumn: "Code",
        pagination: new Pagination(),
        emailTemplates: new Array<EmailTemplate>()
    };

    constructor(private emailTemplateService: EmailTemplatesService,
        private userHomeService: UserHomeService,
        private currentUserService: CurrentUserService,
        private changeDetector: ChangeDetectorRef) {
        this.emailTemplatesComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
    }

    public ngOnInit() {
        // Apply security rules

        // Only global admins can see permissions
        this.hasViewPermission = this.currentUserService.IsGlobalAdmin();
        this.GetEmailTemplateList();
        this.emailTemplate = new EmailTemplate();
    }

    public SortIconClass(columnName): string {
        if (columnName === this.emailTemplatesComponent.sortColumn) {
            if (this.emailTemplatesComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }

    public SortList(columnName: string) {
        this.emailTemplatesComponent.sortOrder = (columnName === this.emailTemplatesComponent.sortColumn 
            && this.emailTemplatesComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) ? USERHOMECONSTANTS.sorting.descOrderString : USERHOMECONSTANTS.sorting.ascOrderString;

        this.emailTemplatesComponent.sortColumn = columnName;
        this.GetEmailTemplateList();
    }

    public PageChanged(currentPageObject) {
        this.emailTemplatesComponent.pagination.currentPage = currentPageObject.page;
        this.GetEmailTemplateList();
    }
    
    // This method is called when submission to update an email template is successful
    // It hides the form by setting the edit mode value to false, then clears the form value by setting the emailTemplate to a blank EmailTemplate
    onSaveSuccessful() {
        this.templateEditMode = false;
        this.emailTemplate = new EmailTemplate();
        this.GetEmailTemplateList();
    }

    // Display the hidden edit form, and retrieve from server the values for the email template based on the code (EmailTemplateCodeId) value.
    public onEditClick(code: string) {
        this.templateEditMode = true;
        this.GetEmailTemplate(code);
    }

    // Get an EmailTemplate object based on the code value, which maps to EmailTemplateCodeId. 
    public GetEmailTemplate(code) {
        this.emailTemplateService
            .GetEmailTemplate(code)
            .map(response => response.json())
            .subscribe(response => {
                this.emailTemplate = <EmailTemplate>response.result;

                // we emit the 'refreshList' event just to force the parent component to reevaluate all input binding, otherwise the new value for 
                // this.emailTemplate would not be observed by the controls that are bound to it
                //this.refreshList.emit(this.emailTemplateList);
                this.changeDetector.detectChanges();
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.emailTemplate;
                }
            });
    }

    // Retrieve the list of EmailTemplate objects from db, and then call the 'refreshList' event listener, defined in the component that uses this component
    public GetEmailTemplateList(): void {
        this.emailTemplateService
            .GetEmailTemplateList(this.emailTemplatesComponent.pagination, this.emailTemplatesComponent.sortOrder,
            this.emailTemplatesComponent.sortColumn)
            .map(response => response.json())
            .subscribe(
            response => {
                this.refreshList.emit(<EmailTemplate[]>response.result);
                this.emailTemplatesComponent.pagination.totalItems = response.count; // get from the response 
                this.userHomeService.confirmTotalItemUpdate(response.count); // get from the response
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.emailTemplate;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/emailTemplates/emailTemplates.component.ts